import {
    openDesktopNav,
    closeDesktopNav,
    closeAllDesktopMainNavs,
    closeAllDesktopUtilityNavs,
    openLoginDropdown,
    closeLoginDropdown,
    closeAllDesktopDropdowns,
    openDesktopLocationSelect,
    closeDesktopLocationSelect
} from '../menus.js';

function initUtilityNavKeyboardNavigation() {
	//utility nav keyboard navigation
    $('body').on('keydown', '.top-utility', function (e) {
        var menu = $(e.target).closest('.utility-nav-item').find('> a'),
            submenu,
            submenuContainer;

        if (e.which == 27) { //esc

            submenu = $(e.target).closest('.utility-nav-item').find('.submenu-open');
            submenuContainer = submenu.closest('.utility-sub');

            if (submenu.length > 0) {
                closeDesktopNav(menu);
                menu.addClass('keyboard-focus').on('blur', function () {
                    $(this).off('blur').removeClass('keyboard-focus');
                }).get(0).focus();

                return false;
            }
        } else if (e.which == 40 || e.which == 13) { //down arrow or enter

            submenu = menu.closest('.utility-nav-item').find('.utility-sub-inner');
            submenuContainer = submenu.closest('.utility-sub');

            if (submenu.length > 0) {

                //top level
                if ($(e.target).is('.utility-trigger')) {

                    if (submenu.is(':not(.submenu-open)')) {
                        //close all other menus
                        closeAllDesktopUtilityNavs();

                        //open submenu
                        openDesktopNav(menu);
                    }

                    //select first submenu item
                    submenu.find('a').first().addClass('keyboard-focus').on('blur', function () {
                        $(this).off('blur').removeClass('keyboard-focus');
                    }).get(0).focus();

                    return false;

                //move down inside submenu
                } else if ($(e.target).is('.utility-sub-inner a')) {
                    //select next submenu item
                    let anchor = $(e.target).next('a');

                    //wrap to first item
                    if (anchor.length == 0) {
                        anchor = submenu.find('a').first();
                    }

                    //focus next submenu item
                    if (anchor.length > 0) {
                        anchor.addClass('keyboard-focus').on('blur', function () {
                            $(this).off('blur').removeClass('keyboard-focus');
                        }).get(0).focus();
                    }

                    return false;
                }
            }

        } else if (e.which == 38) { //up arrow
            submenu = menu.closest('.utility-nav-item').find('.utility-sub-inner');
            submenuContainer = submenu.closest('.utility-sub');

            if (submenu.length > 0) {
                //top level
                if ($(e.target).is('.utility-trigger')) {

                    if (submenu.is(':not(.submenu-open')) {
                        //close all other menus
                        closeAllDesktopUtilityNavs();

                        //open submenu
                        openDesktopNav(menu);
                    }

                    //select last submenu item
                    submenu.find('a').last().addClass('keyboard-focus').on('blur', function () {
                        $(this).off('blur').removeClass('keyboard-focus');
                    }).get(0).focus();

                    return false;

                //move up inside submenu
                } if ($(e.target).is('.utility-sub-inner a')) {
                    //select previous submenu item
                    let anchor = $(e.target).prev('a');

                    //wrap to last item
                    if (anchor.length == 0) {
                        anchor = submenu.find('a').last();
                    }

                    //focus previous submenu item
                    if (anchor.length > 0) {
                        anchor.addClass('keyboard-focus').on('blur', function () {
                            $(this).off('blur').removeClass('keyboard-focus');
                        }).get(0).focus();
                    }

                    return false;
                }
            }
        } else if (e.which == 37) { //left arrow

            submenu = menu.closest('.utility-nav-item').find('.utility-sub-inner');
            submenuContainer = submenu.closest('.utility-sub');

            //find previous menu item
            let anchor = menu.closest('.utility-nav-item').prev('.utility-nav-item').find('> a');

            //wrap to last item
            if (anchor.length == 0) {
                anchor = menu.closest('.utility-nav-item').nextAll('.utility-nav-item').last().find('> a');
            }

            //close submenu
            let wasOpen = menu.is('.open');
            closeDesktopNav(menu);

            //focus previous menu item
            if (anchor.length > 0) {
                anchor.addClass('keyboard-focus').on('blur', function () {
                    $(this).off('blur').removeClass('keyboard-focus');
                }).get(0).focus();

                if (wasOpen) {
                    //open submenu
                    let newSubmenu = anchor.closest('.utility-nav-item').find('.utility-sub-inner');
                    if (newSubmenu.length > 0) {
                        openDesktopNav(anchor);
                    }
                }

                return false;
            }

        } else if (e.which == 39) { //right arrow

            submenu = menu.closest('.utility-nav-item').find('.utility-sub-inner');
            submenuContainer = submenu.closest('.utility-sub');

            //find next menu item
            let anchor = menu.closest('.utility-nav-item').next('.utility-nav-item').find('> a');

            //wrap to first item
            if (anchor.length == 0) {
                anchor = menu.closest('.utility-nav-item').prevAll('.utility-nav-item').last().find('> a'); //prevAll returns array ordered closest to furthest, not DOM order
            }

            //close submenu
            let wasOpen = menu.is('.open');
            closeDesktopNav(menu);

            //focus previous menu item
            if (anchor.length > 0) {
                anchor.addClass('keyboard-focus').on('blur', function () {
                    $(this).off('blur').removeClass('keyboard-focus');
                }).get(0).focus();

                if (wasOpen) {
                    //open submenu
                    let newSubmenu = anchor.closest('.utility-nav-item').find('.utility-sub-inner');
                    if (newSubmenu.length > 0) {
                        openDesktopNav(anchor);
                    }
                }

                return false;
            }
        } else if (e.which == 36) { //home key

            submenu = menu.closest('.utility-nav-item').find('.utility-sub-inner');
            submenuContainer = submenu.closest('.utility-sub');

            if ($(e.target).is('.utility-nav-item > a')) {

                if (menu.closest('.utility-nav-item').is(':first-child')) {
                    return false;
                }

                //find first menu item (prevAll returns array ordered closest to furthest, not DOM order)
                let anchor = menu.closest('.utility-nav-item').prevAll('.utility-nav-item').last().find('> a');

                //close submenu
                let wasOpen = menu.is('.open');
                closeDesktopNav(menu);

                //focus previous menu item
                if (anchor.length > 0) {
                    anchor.addClass('keyboard-focus').on('blur', function () {
                        $(this).off('blur').removeClass('keyboard-focus');
                    }).get(0).focus();

                    if (wasOpen) {
                        //open submenu
                        let newSubmenu = anchor.closest('.utility-nav-item').find('.utility-sub-inner');
                        if (newSubmenu.length > 0) {
                            openDesktopNav(anchor);
                        }
                    }
                }

                return false;

            } else if ($(e.target).is('.utility-sub-inner a')) {

                let anchor = submenu.find('a').first();

                //focus previous submenu item
                if (anchor.length > 0) {
                    anchor.addClass('keyboard-focus').on('blur', function () {
                        $(this).off('blur').removeClass('keyboard-focus');
                    }).get(0).focus();
                }

                return false;
            }
        } else if (e.which == 35) { //end key

            submenu = menu.closest('.utility-nav-item').find('.utility-sub-inner');
            submenuContainer = submenu.closest('.utility-sub');

            if ($(e.target).is('.utility-nav-item > a')) {

                if (menu.closest('.utility-nav-item').is(':last-child')) {
                    return false;
                }

                //find last menu item
                let anchor = menu.closest('.utility-nav-item').nextAll('.utility-nav-item').last().find('> a');

                //close submenu
                let wasOpen = menu.is('.open');
                closeDesktopNav(menu);

                //focus previous menu item
                if (anchor.length > 0) {
                    anchor.addClass('keyboard-focus').on('blur', function () {
                        $(this).off('blur').removeClass('keyboard-focus');
                    }).get(0).focus();

                    if (wasOpen) {
                        //open submenu
                        let newSubmenu = anchor.closest('.utility-nav-item').find('.utility-sub-inner');
                        if (newSubmenu.length > 0) {
                            openDesktopNav(anchor);
                        }
                    }
                }

                return false;

            } else if ($(e.target).is('.utility-sub-inner a')) {
                //select last submenu item
                let anchor = submenu.find('a').last();

                //focus previous submenu item
                if (anchor.length > 0) {
                    anchor.addClass('keyboard-focus').on('blur', function () {
                        $(this).off('blur').removeClass('keyboard-focus');
                    }).get(0).focus();
                }

                return false;
            }
        } else if (e.which == 9) { //tab key
            submenu = menu.closest('.utility-nav-item').find('.utility-sub-inner');
            submenuContainer = submenu.closest('.utility-sub');

            //if target is last anchor in last dropdown or last top-level nav in main nav, close the submenu
            if (
                (
                    !e.shiftKey &&
                    $(e.target).is('> a, .utility-sub-inner a:last-child') &&
                    $(e.target).closest('.utility-nav-item').is(':last-child')
                ) || (
                    e.shiftKey &&
                    $(e.target).is('> a') &&
                    $(e.target).closest('.utility-nav-item').is(':first-child')
                )) {
                closeAllDesktopUtilityNavs();
            }
        }
    });
}

export { initUtilityNavKeyboardNavigation };